import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Rubrica from './views/Rubrica.vue';
import RdsMedia from './views/RdsMedia.vue';
import Eventi from './views/Eventi.vue';
import Mensa from './views/Mensa.vue';
import Profilo from './views/Profilo.vue';
import Market from './views/Market.vue';
// import MarketItem from './views/MarketItem';
import Reservations from './views/Reservations';
import Login from './views/Login';
import userService from './services/User.service';
// import Navetta from './views/Navetta';
import Benefits from './views/Benefits';
import TestTornelli from './views/TestTornelli';
import Chat from './views/Chat';
import EditImage from './views/EditImage';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: 'Home'
      },
      component: Home
    },
    {
      path: '/edit-image',
      name: 'editImage',
      meta: {
        title: 'Edit Image'
      },
      component: EditImage
    },
    {
      path: '/rubrica',
      name: 'rubrica',
      meta: {
        title: 'Rubrica'
      },
      component: Rubrica
    },
    {
      path: '/rdsMedia',
      name: 'rdsMedia',
      meta: {
        title: 'Media'
      },
      component: RdsMedia
    },
    {
      path: '/eventi',
      name: 'eventi',
      meta: {
        title: 'Eventi'
      },
      component: Eventi
    },
    {
      path: '/mensa*',
      name: 'mensa',
      meta: {
        title: 'Mensa'
      },
      component: Mensa
    },
    {
      path: '/profile',
      name: 'profile',
      meta: {
        title: 'Profilo'
      },
      component: Profilo
    },
    {
      path: '/profile/edit',
      name: 'editProfile',
      meta: {
        title: 'Profilo'
      },
      component: Profilo
    },
    // {
    //   path: '/item',
    //   name: 'item',
    //   meta: {
    //     title: 'RDS Market'
    //   },
    //   component: MarketItem
    // },
    {
      path: '/market',
      name: 'market',
      meta: {
        title: 'RDS Market'
      },
      component: Market
    },
    {
      path: '/beauty',
      name: 'beauty',
      meta: {
        title: 'Beauty'
      },
      component: Reservations
    },
    {
      path: '/barbecue',
      name: 'barbecue',
      meta: {
        title: 'Barbecue'
      },
      component: Reservations
    },
    {
      path: '/navetta',
      name: 'navetta',
      meta: {
        title: 'Navetta'
      },
      component: Reservations
    },
    {
      path: '/bike',
      name: 'bike',
      meta: {
        title: 'Bike'
      },
      component: Reservations
    },
    {
      path: '/palestra',
      name: 'palestra',
      meta: {
        title: 'Palestra'
      },
      component: Reservations
    },
    {
      path: '/benefits',
      name: 'Benefits',
      meta: {
        title: 'Benefits'
      },
      component: Benefits
    },
    {
      path: '/campus-biomedico',
      name: 'Benefits - Campus',
      meta: {
        title: 'Benefits'
      },
      component: Benefits
    },
    {
      path: '/e-learning',
      name: 'Elearning',
      meta: {
        title: 'RDS Learning'
      },
      component: Benefits
    },
    {
      path: '/test-tornelli',
      name: 'testTornelli',
      meta: {
        title: 'Tornelli'
      },
      component: TestTornelli
    },
    {
      path: '/chat',
      name: 'chat',
      meta: {
        title: 'Chat'
      },
      component: Chat
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: 'Login'
      },
      component: Login,
      beforeEnter: (to, from, next) => {
        if (userService.isAuthenticated()) {
          next(from.path !== '/login' ? from.path : '/');
        } else {
          next();
        }
      }
    },
    { path: '*', redirect: '/' },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js)å for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(/* webpackChunkName: "about" */ './views/About.vue');
      }
    }
  ]
});
